import useLoadableBulk from '../use-loadable-bulk';

const useLoadable = ({ callback, actionPrefix }) => {
  const { load, data } = useLoadableBulk({
    callbacks: callback ? [callback] : [],
    actionPrefix
  });
  return { load, ...data[0] };
};

export default useLoadable;
